import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { useEffect } from "react";
import { useState } from "react";

function CustomTooltip({
  id = "uniqueId",
  content = "",
  linesVisible = 2,
  sx = {},
}) {
  const [lines, setLines] = useState(1);

  useEffect(() => {
    let element = document.getElementById(id);
    let fontSize = parseFloat(getComputedStyle(element).fontSize);
    let numberOfLines = Math.floor(element.offsetHeight / fontSize);
    setLines(numberOfLines);
  }, [id]);

  return lines > linesVisible ? (
    <Tooltip
      title={content}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#fff",
            color: "#3A3A3A",
            fontSize: "1.2rem",
            padding: "8px",
            border: "1px solid lightgray",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.25)",
            "& .MuiTooltip-arrow": {
              color: "#fff",
              width: "2rem",
              height: "1rem",
            },
            "& .MuiTooltip-arrow::before": {
              border: "1px solid lightgray",
            },
            [".MuiTooltip-popper[data-popper-placement*='bottom'] &"]: {
              marginTop: "1rem !important",
              ".MuiTooltip-arrow": {
                marginTop: "-1rem !important",
              },
            },
            [".MuiTooltip-popper[data-popper-placement*='top'] &"]: {
              marginBottom: "1rem !important",
              ".MuiTooltip-arrow": {
                marginBottom: "-1rem !important",
              },
            },
            ...sx,
          },
        },
      }}
    >
      <span
        id={id}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          "-webkit-line-clamp": linesVisible?.toString(),
          "-webkit-box-orient": "vertical",
        }}
      >
        {content}
      </span>
    </Tooltip>
  ) : (
    <span id={id}>{content}</span>
  );
}

export default CustomTooltip;
